import(/* webpackMode: "eager" */ "/vercel/path0/src/app/katalog/page.tsx");
